import component from './Modal.vue'
export default component
